import { Component, OnInit } from '@angular/core';
import { Globals } from '.././globals';
import { AuthService } from '../services/auth.service';
import { CookieService } from 'ngx-cookie-service';
import { Router, ActivatedRoute } from '@angular/router';
import { LearningPathService } from '../app-assessment_covid/services/learning-path.service';
import { RoleValueEnum } from '../globals-enum';
declare var $: any;

@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.css'],
})
export class SideMenuComponent implements OnInit {
  permissions: any = [];
  accessConfigData: boolean = false;
  administrator_present: boolean = false;
  connector_present: boolean = false;
  covid_present: boolean = false;
  dcm_present: boolean = false;
  productList: any = [];
  is_individual = false;
  highest_role_value = 0;
  org_dcm_present: boolean = false;
  flag: boolean = false;
  completeAssessmentList:any
  selectedAssessment:any
  clickTabFlag:string
  public opened = false;
  public roleEnum: typeof RoleValueEnum;

  
  constructor(
    public globals: Globals,
    private authService: AuthService,
    private CookieService: CookieService,
    private router: Router,
    private leanringPathService: LearningPathService,
    
  ) {
    this.roleEnum = RoleValueEnum;

  }

  ngOnInit(): void {
    this.getPermission();
    if(this.globals.authData.id!=this.CookieService.get('user_token')){
      setTimeout(() => {
        this.authService.getAuthUser()
        .then((data) => { 
          this.getMyProductData();
        },
        (error) => {
          this.globals.errorSweetAlert();
        });
      }, 500);
    } else {
      this.getMyProductData();
    }  

    this.accessConfigData =
      $.inArray(
        this.globals.authData.id,
        this.globals.usersAccessConfigData
      ) !== -1
        ? true
        : false;

    if (
      this.globals.institute_details &&
      this.globals.institute_details.institute &&
      this.globals.institute_details.institute.id
    ) {
      this.is_individual = false;
    } else {
      this.is_individual = true;
    }

    this.leanringPathService.currentFlag.subscribe(
      (flag) => (this.flag = flag)
    );
    this.loadLearningPathMenuFlag();
  }

  loadLearningPathMenuFlag() {
    if (!this.globals.authData?.id) {
      return;
    }
    this.leanringPathService
      .getEligibleAssessments(
        this.globals.authData.id,
        this.CookieService.get('user_token'),
      )
      .then((list: any[]) => {
        if (list.length > 0) {
          this.flag = true;
          this.leanringPathService.updateFlag(true);
          this.leanringPathService.ensureLearningPathContext(list[0]);
        }
      })
      .catch(() => {});
  }

  getMyProductData() {
    if (this.globals.authData.id) {
      let postdata = { user_id: this.globals.authData.id };
      this.authService.getUserRoleList(postdata).then(
        (data) => {
          let productList = data['data'];

          let connector_present = false;
          let covid_present = false;
          let dcm_present = false;
          let org_dcm_present = false;
          let administrator_present = false;
          const current_role: any = this.globals.institute_details.role_value;

          this.productList = productList.filter((value) => {
            if (this.highest_role_value == 0) {
              this.highest_role_value = value.role_value;
            } else {
              if (value.role_value == RoleValueEnum.OESS_Administrator) {
                this.highest_role_value = RoleValueEnum.OESS_Administrator;
              } else if (
                value.role_value == RoleValueEnum.IFMA_Administrator &&
                this.highest_role_value != RoleValueEnum.OESS_Administrator
              ) {
                this.highest_role_value = RoleValueEnum.IFMA_Administrator;
              } else if (
                value.role_value == RoleValueEnum.Division_Head &&
                this.highest_role_value != RoleValueEnum.OESS_Administrator &&
                this.highest_role_value != RoleValueEnum.IFMA_Administrator
              ) {
                this.highest_role_value = RoleValueEnum.Division_Head;
              } else if (
                value.role_value == RoleValueEnum.Cohort &&
                this.highest_role_value != RoleValueEnum.OESS_Administrator &&
                this.highest_role_value != RoleValueEnum.IFMA_Administrator &&
                this.highest_role_value != RoleValueEnum.Division_Head
              ) {
                this.highest_role_value = RoleValueEnum.Cohort;
              }
            }

            if (value.role_value == RoleValueEnum.OESS_Administrator || value.role_value == RoleValueEnum.IFMA_Administrator) {
              value.product_list.forEach(function (item) {
                if (item.product.value == 1) {
                  connector_present = true;
                } else if (item.product.value == 2) {
                  administrator_present = true;
                } else if (item.product.value == 3) {
                  administrator_present = true;
                }
              });
            } else if (value.role_value == RoleValueEnum.Individual_User) {
              value.product_list.forEach(function (item) {
                if (item.product.value == 2) {
                  covid_present = true;
                } else if (item.product.value == 3) {
                  dcm_present = true;
                }
              });
            } else if (value.role_value == RoleValueEnum.Organazation_User) {
              value.product_list.forEach(function (item) {
                if (item.product.value == 3) {
                  org_dcm_present = true;
                }
              });
            } else if (value.role_value == RoleValueEnum.Cohort || value.role_value == RoleValueEnum.Division_Head) {
              value.product_list.forEach(function (item) {
                if (item.product.value == 1) {
                  connector_present = true;
                } else if (item.product.value == 2) {
                  administrator_present = true;
                } else if (item.product.value == 3) {
                  administrator_present = true;
                  org_dcm_present = true;
                }
              });
            }
            return value;
          });

          this.productList;
          this.connector_present = connector_present;
          this.covid_present = covid_present;
          this.dcm_present = dcm_present;
          this.org_dcm_present = org_dcm_present;
          this.administrator_present = administrator_present;
        },
        (error) => {
          this.globals.isLoading = false;
          this.globals.errorSweetAlert();
        }
      );
    }
  }

  getPermission() {
    if (
      localStorage.getItem('last_updated_date_role_permission') &&
      localStorage.getItem('user_role_permission')
    ) {
      this.authService.getLastUpdatedDateOfRolePermission().then(
        (res: any) => {
          let lastUpdatedDateRolePermission = new Date(res['data'].updated_at);
          let cookie_date = new Date(
            window.atob(
              localStorage.getItem('last_updated_date_role_permission')
            )
          );
          if (lastUpdatedDateRolePermission <= cookie_date) {
            if (
              window.atob(this.CookieService.get('current_role_value')) ==
              this.globals.institute_details?.role_value
            ) {
              let data = JSON.parse(
                window.atob(localStorage.getItem('user_role_permission'))
              );
              this.globals.permissions = data;
            } else {
              this.CookieService.set(
                'current_role_value',
                window.btoa(this.globals.institute_details.role_value),
                365,
                '/',
                this.globals.CookieDomainUrl
              );
              let permission_data = JSON.parse(
                window.atob(localStorage.getItem('all_role_permission'))
              );
              let active_license =
                this.globals.institute_details.active_license > 0 ? 0 : 0;
              let retrievedObject1 = permission_data.filter((item) => {
                if (
                  item.role_value ==
                    this.globals.institute_details.role_value &&
                  item.is_accessible_after_expire == active_license
                ) {
                  return item;
                }
              })[0].permission_list;

              let user_role_permission = {};
              let index;
              this.globals.permissionText.forEach(function (menu, key) {
                index = retrievedObject1.findIndex(
                  (retrievedObject1) =>
                    retrievedObject1.slug === menu.key &&
                    retrievedObject1.has_access == 1
                );
                if (index != -1) {
                  user_role_permission[menu.key] = true;
                } else {
                  user_role_permission[menu.key] = false;
                }
              });
              localStorage.setItem(
                'user_role_permission',
                window.btoa(JSON.stringify(user_role_permission))
              );
              this.globals.permissions = user_role_permission;
            }
          } else {
            this.authService.getAllRolePermissionData1();
          }
        },
        (error) => {
          this.globals.isLoading = false;
          this.globals.errorSweetAlert();
        }
      );
    } else {
      this.authService.getAllRolePermissionData1();
    }
  }

  goToDirectConnector() {
    let institute_details = null;

    if (this.highest_role_value == RoleValueEnum.OESS_Administrator || this.highest_role_value == RoleValueEnum.IFMA_Administrator) {
      let role = this.highest_role_value;
      this.globals.authData.list.forEach(function (value) {
        if (value.role_value == role) {
          institute_details = value;
        }
      });
    } else {
      institute_details = this.productList.filter(
        (s) => s.role_value == this.highest_role_value
      )[0];
    }

    this.CookieService.set(
      'institute_details',
      window.btoa(JSON.stringify(institute_details)),
      365,
      '/',
      this.globals.CookieDomainUrl
    );

    window.location.href = this.globals.connectorUrl + '/overview-dashboard';

  }

  registerOrg() {
    this.CookieService.delete(
      'institute_details',
      '/',
      this.globals.CookieDomainUrl
    );
    this.CookieService.delete(
      'current_product',
      '/',
      this.globals.CookieDomainUrl
    );
    this.CookieService.delete(
      'current_product_id',
      '/',
      this.globals.CookieDomainUrl
    );
    window.location.href =
      this.globals.connectorUrl + '/organization-registration';
  }

  viewIndividualDCM() {
    let institute_details = this.globals.authData.list.filter(
      (s) => s.role_value == RoleValueEnum.Individual_User
    )[0];
    this.CookieService.set(
      'institute_details',
      window.btoa(JSON.stringify(institute_details)),
      365,
      '/',
      this.globals.CookieDomainUrl
    );
    window.location.href = this.globals.baseUrl;
  }

  viewOrgDCM() {
    let institute_details = this.productList.filter(
      (s) => s.role_value == RoleValueEnum.Cohort || s.role_value == RoleValueEnum.Organazation_User || s.role_value == RoleValueEnum.Division_Head
    )[0];

    this.CookieService.set(
      'institute_details',
      window.btoa(JSON.stringify(institute_details)),
      365,
      '/',
      this.globals.CookieDomainUrl
    );

    window.location.href = this.globals.baseUrl;
  }

  viewAdmin() {
   
    this.CookieService.delete(
      'current_product',
      '/',
      this.globals.CookieDomainUrl
    );
    this.CookieService.delete(
      'current_product_id',
      '/',
      this.globals.CookieDomainUrl
    );
    window.location.href = this.globals.adminUrl;
    
  }

 

  viewSAT() {
 
    this.CookieService.delete(
      'current_product',
      '/',
      this.globals.CookieDomainUrl
    );
    this.CookieService.delete(
      'current_product_id',
      '/',
      this.globals.CookieDomainUrl
    );
    window.location.href = this.globals.dcmUrl;
  }

  public close(): void {
    this.opened = false;
  }

  goToLearningPath(flag: any) {
    this.clickTabFlag = flag;
    const userClickData = localStorage.getItem('userClickLp');
    var userClickEvent = userClickData ? JSON.parse(userClickData) : null;
    if(this.globals.currentLink.split('/')[2]=='learning-path'){
      this.opened = false
      this.router.navigate(['/assessment/learning-path']);
    }
    else{
      if(userClickEvent?.assementId){
        this.router.navigate(['/assessment/learning-path']);
      }
      else{
        this.getDialougeData();
      }
    }
    
  
  }

  gotoFavourite(flag: any) {
    if (flag == 'direct') {
      const lpData = localStorage.getItem('userClickLp');
      let favoriteData: any = {
        direct: true,
        overall_rating: '1',
      };
      try {
        const lp = lpData ? JSON.parse(lpData) : null;
        if (lp?.assementId) {
          favoriteData = {
            ...favoriteData,
            assementId: lp.assementId,
            overall_rating: lp.overall_rating || '1',
          };
        }
      } catch (error) {}
      localStorage.setItem('userClickFv', JSON.stringify(favoriteData));
      this.router.navigate(['/assessment/favorite']);
    }
  }
  async getDialougeData(): Promise<void> {
    this.globals.isLoading = true;
    try {
      this.completeAssessmentList =
        await this.leanringPathService.getEligibleAssessments(
          this.globals.authData.id,
          this.CookieService.get('user_token'),
        );
      if (this.completeAssessmentList?.length === 1) {
        this.selectedAssessment = this.completeAssessmentList[0];
        this.leanringPathService.ensureLearningPathContext(
          this.selectedAssessment,
        );
        localStorage.setItem(
          'userClickLp',
          JSON.stringify({
            overAll: true,
            overall_rating: this.selectedAssessment.overall_rating,
            assementId:
              this.selectedAssessment.id ||
              this.selectedAssessment.assessment_id,
            institute_name: this.selectedAssessment.institute_name,
          }),
        );
        this.router.navigate(['/assessment/learning-path']);
        return;
      }
      this.opened = true;
    } catch (error) {
    } finally {
      this.globals.isLoading = false;
    }
  }

  assessmentChange(assessment: any) {
    this.selectedAssessment = assessment;
  }

  onSubmit(form: any) {
    if (form.valid) {
      if (this.clickTabFlag == 'learning') {
        var overAllData = {
          overAll: true,
          overall_rating: this.selectedAssessment.overall_rating,
          assementId: this.selectedAssessment.id,
          institute_name: this.selectedAssessment.institute_name,
        };
        localStorage.setItem('userClickLp', JSON.stringify(overAllData));
        this.opened = false;
        this.globals.isLoading = false;
        form.reset();
        this.router.navigate(['/assessment/learning-path']);
      } 
      
    } else {
    }
  }
}
